import moment from "moment-timezone";

export const AU_LOGS_TIME_ZONE = "Australia/Melbourne";
export const NZ_LOGS_TIME_ZONE = "Pacific/Auckland";

export function logsTimeZoneForRegionFilter(region) {
  return String(region || "").toUpperCase() === "NZ" ? NZ_LOGS_TIME_ZONE : AU_LOGS_TIME_ZONE;
}

export function logsTimeZoneLabel(region) {
  return String(region || "").toUpperCase() === "NZ" ? "NZ (Pacific/Auckland)" : "AEDT (Australia/Melbourne)";
}

/** Display log timestamps in the timezone implied by the region filter (default Melbourne / AEDT). */
export function formatAdminLogDateTime(value, regionFilter) {
  if (!value) return "—";
  const m = moment(value);
  if (!m.isValid()) return "—";
  const tz = logsTimeZoneForRegionFilter(regionFilter);
  const locale = String(regionFilter || "").toUpperCase() === "NZ" ? "en-NZ" : "en-AU";
  return m.tz(tz).format("D MMM YYYY, HH:mm:ss z");
}

/** Interpret YYYY-MM-DD as start or end of that calendar day in the given region timezone → ISO UTC. */
export function calendarDayToIso(value, regionFilter, endOfDay) {
  if (!value) return null;
  const tz = logsTimeZoneForRegionFilter(regionFilter);
  const base = moment.tz(value, "YYYY-MM-DD", tz);
  if (!base.isValid()) return null;
  const bound = endOfDay ? base.endOf("day") : base.startOf("day");
  return bound.toDate().toISOString();
}
